export default __webpack_public_path__ + "static/media/Princess@3x.75aba896.png";